import { X } from "lucide-react";
import dayjs from "dayjs";
import DateRangeField, { DEFAULT_SHORTCUTS } from "../../components/DateRangeField";

const SHORTCUTS = [
  DEFAULT_SHORTCUTS.find((s) => s.label === "Today"), //
  DEFAULT_SHORTCUTS.find((s) => s.label === "This week"), //
  DEFAULT_SHORTCUTS.find((s) => s.label === "Last week"),
  DEFAULT_SHORTCUTS.find((s) => s.label === "This month"),
  DEFAULT_SHORTCUTS.find((s) => s.label === "Last month"),
  // DEFAULT_SHORTCUTS.find((s) => s.label === "This year"),
];

// Default range for the picker: today, start of day to end of day
const defaultTodayRange = () => {
  const t = dayjs();
  return [t.startOf("day"), t.endOf("day")];
};

export default function QuickFilterModal({ isOpen, filter, ghlAttendees, kixieAttendees, onChange, onClose, onClear, onApply }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-sm font-semibold text-gray-800">Quick Filters</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-lg">
            <X size={15} />
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2 flex flex-col justify-center items-center w-full">
            <label className="block text-xs text-gray-500 mb-1">Date Range</label>
            <DateRangeField from={filter.from} to={filter.to} onCustomRangeChange={({ from, to }) => onChange({ ...filter, from, to })} shortcuts={SHORTCUTS} disableFuture={true} defaultRange={defaultTodayRange} />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">GHL Agent</label>
            <select value={filter.agent} onChange={(e) => onChange({ ...filter, agent: e.target.value })} className="w-full border rounded-lg px-3 py-2 text-sm">
              <option value="">Select GHL Agent</option>
              {(ghlAttendees || []).map((agent, index) => (
                <option key={`ghl-${index}`} value={agent}>
                  {agent || "Unknown"}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Kixie Agent</label>
            <select value={filter.kixieAgent || ""} onChange={(e) => onChange({ ...filter, kixieAgent: e.target.value })} className="w-full border rounded-lg px-3 py-2 text-sm">
              <option value="">Select Kixie Agent</option>
              {(kixieAttendees || []).map((agent, index) => (
                <option key={`kixie-${index}`} value={agent}>
                  {agent || "Unknown"}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">GHL Duration Threshold (sec)</label>
            <input type="number" min={1} value={filter.ghlThreshold ?? 60} onChange={(e) => onChange({ ...filter, ghlThreshold: e.target.value === "" ? "" : Number(e.target.value) })} placeholder="60" className="w-full border rounded-lg px-3 py-2 text-sm" />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Kixie Duration Threshold (sec)</label>
            <input type="number" min={1} value={filter.kixieThreshold ?? 30} onChange={(e) => onChange({ ...filter, kixieThreshold: e.target.value === "" ? "" : Number(e.target.value) })} placeholder="30" className="w-full border rounded-lg px-3 py-2 text-sm" />
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-5">
          <button onClick={onClear} className="px-4 py-2 min-w-32 text-sm rounded-md shadow-sm border hover:bg-gray-200 duration-200 ease-in-out">
            Clear
          </button>
          <button onClick={onApply} className="px-4 py-2 min-w-32 text-sm rounded-md shadow-sm bg-sky-400 hover:bg-sky-600 duration-200 ease-in-out text-white">
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
